import { useEffect, useState } from "react";
import { db } from "services/firebase";
import { useAuth } from "@healthdesk/shared-hooks";

/**
 * Active facilityGrantedEntitlements for the signed-in patient.
 * Client-side filter on expiresAt (query by patientId+status; filter expiry in memory).
 */
export default function useFacilityGrantedEntitlements() {
  const { user } = useAuth();
  const [grants, setGrants] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!user?.uid) {
      setGrants([]);
      setLoading(false);
      return undefined;
    }

    setLoading(true);
    const unsub = db
      .collection("facilityGrantedEntitlements")
      .where("patientId", "==", user.uid)
      .where("status", "==", "active")
      .onSnapshot(
        (snap) => {
          const now = new Date();
          const active = snap.docs
            .map((doc) => ({ id: doc.id, ...doc.data() }))
            .filter((g) => {
              const exp = g.expiresAt?.toDate
                ? g.expiresAt.toDate()
                : g.expiresAt
                  ? new Date(g.expiresAt)
                  : null;
              return exp && exp > now;
            });
          setGrants(active);
          setLoading(false);
        },
        () => {
          setGrants([]);
          setLoading(false);
        },
      );

    return () => unsub();
  }, [user?.uid]);

  return { grants, loading };
}
